<template>
    <div>
        <b><span>
            Humedad Relativa actual: {{ ultima_humedad }} %
        </span></b>
        <br>
        <span>
            Humedad Relativa máxima (últimas 24 horas): {{ humedad_maxima }} %
        </span>
        <br>
        <span>
            Humedad Relativa media (últimas 24 horas): {{ humedad_media }} %
        </span>
        <br>
        <span>
            Humedad Relativa mínima (últimas 24 horas): {{ humedad_minima }} %
        </span>
        <br>
        <span>
            Datos recuperados: {{ datos_recuperados }}%
        </span>
        <br>
        <span>
            Última transmisión: {{ ultima_transmision }}
        </span>
        <Graph 
            chart-title="Humedad Relativa (últimas 24 horas)"
            :data-series="humidities" 
            :yleyend="'Humedad Relativa (%)'" 
            :xleyend="leyend" 
            :id-div="3+index"
        />
    </div>
</template>

<script>
    import Graph from '../Graphs/Graph';

    export default {
        name: "Humidity",

        components:{
            Graph
        },

        props:{
            charts: [],
            index: Number
        },

        data(){
            return{
                ultima_humedad: 0,
                ultima_transmision: '',
                humedad_maxima: 0,
                humedad_media: 0,
                humedad_minima: 0,
                datos_recuperados: 0,
                humidities: [],
                leyend: []
            }
        },

        created(){
            this.Get_Humidities();
        },

        methods:{
            /*
            * Se calculan los datos que no son nulos y se almacena su fecha y hora
            * Aquí se crea el array para constuir las series de las gráficas y el eje horizontal
            */
            Get_Humidities(){
                const datos = [];
                let suma = 0;

                for(var i in this.charts){
                    let humedad = parseFloat(this.charts[i].humidity);

                    if(!isNaN(humedad)){
                        datos.push(parseFloat(humedad.toFixed(0)));
                        this.leyend.push(this.charts[i].date+"<br/>"+this.charts[i].time);
                        suma += humedad;
                    }
                }

                this.humedad_maxima = Math.max.apply(null,datos);
                this.humedad_media = (suma/datos.length).toFixed(0);
                this.humedad_minima = Math.min.apply(null,datos);
                this.ultima_humedad = datos[datos.length-1];
                let fecha_hora = this.leyend[this.leyend.length -1];
                this.ultima_transmision = fecha_hora.replace('<br/>',' ');

                this.datos_recuperados = (datos.length*100/this.charts.length).toFixed(1);

                /*
                * Estos son los datos que se envían para constuir la gráfica
                * el tipo de gráfica, el nombre de la serie, el color y los datos de las series.
                */

                this.humidities = [{
                    type: "area",
                    name: "Humedad Relativa (%)",
                    color: {
                        linearGradient: { x1: 0, x2: 0, y1: 0, y2: 1 },
                        stops: [
                            [0, 'rgba(29,138,1,0.8)'],
                            [1, 'rgba(29,138,1,0.4)']
                        ]
                    },
                    data: datos
                }];
            }
        }
    };
</script>